import { render, staticRenderFns } from "./labellingSetting.vue?vue&type=template&id=7c410cb2&scoped=true&"
import script from "./labellingSetting.vue?vue&type=script&lang=js&"
export * from "./labellingSetting.vue?vue&type=script&lang=js&"
import style0 from "./labellingSetting.vue?vue&type=style&index=0&id=7c410cb2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c410cb2",
  null
  
)

export default component.exports